import { useState, useEffect, useMemo, useDeferredValue } from "react";
import {
  section,
  filterPrimaries,
  sortPrimaries,
} from "../helperFunctions/sortAndFilterFunctions";

export const useSectionedData = (timesheets = [], options, viewWindow) => {
  let sectionedTimesheets = useMemo(() => {
    let filteredData = filterPrimaries(timesheets, options);
    let sectionedData = section(filteredData);
    let limitedData = sectionedData.filter((x, i) => {
      // If user is searching, return ten different sections.
      // Else return number of sections defined by viewWindow
      // if (options.searchTerm) return i < 10;
      return i < (options.viewWindow ?? 10);
    });
    let sortedData = sortPrimaries(limitedData, options);

    return sortedData;
  }, [options, timesheets]);

  const deferredValue = useDeferredValue(sectionedTimesheets);

  // const [sectionedTimesheets, setSectionedTimesheets] = useState([]);

  // useEffect(() => {
  //   let filteredData = filterPrimaries(timesheets, options);
  //   let sectionedData = section(filteredData);
  //   let sortedData = sortPrimaries(sectionedData, options);

  //   setSectionedTimesheets(sortedData);
  // }, [options, timesheets]);

  return deferredValue;
};

// jobReceived: "2020-03-30"
// refNumber: 2075
// uid: "a7e9891e-3fb1-42c0-81ac-7b638ecebd19"
// accessId: undefined
// worksOrderNumber: undefined
// paid: false
// printSelector: true
// discount: 0
// jobDescriptions: []
// jobDetails: ""
// hours: 0
// hourRate: 0
// multiplier: 0
// jobLocation: ""
// materialsCost: "0.00"
// __proto__: Object
// 1:
// accessId: "PHenderson"
// address: "1162 Tollcross Road"
// address2: ""
// authorisedBy: "Johnynk kjd "
// city: "Glasgow"
// customerId: "sD7MhYycCkvTLlpD5FI5"
// email: "paulyk1162@hotmail.co.uk"
// flat: "2/2"
// jobDetails: "new state change<br>2020-03-21 th  lsk sl aslkslslk slksa salksalk<br>2020-03-08 Hello this is the second thing<br>2020-03-26 Nevermind it is the third thing.<br>2020-03-12 "
// jobEnd: "2020-03-28"
// jobReceived: "2019-06-14"
// jobStart: "2020-03-13"
// name: "Paul Henderson"
// number: "099 111 333"
// paid: false
// postcode: "G6 283"
// refNumber: "2090"
// uid: "389fea7f-9410-4b59-856b-e5d151c65cc1"
// unit: ""
// worksOrderNumber: "333kkk3"
// printSelector: true
// discount: 0
// jobDescriptions: (4)[{ … }, { … }, { … }, { … }]
// hours: 16
// hourRate: "1"
// multiplier: 1.5
// jobLocation: "1162 Tollcross Road, Flat 2/2, Glasgow, G6 283"
// materialsCost: "17.52"
